import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=5954b6a2&scoped=true&"
import script from "./companyInfo.vue?vue&type=script&lang=js&"
export * from "./companyInfo.vue?vue&type=script&lang=js&"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=5954b6a2&scoped=true&lang=css&"
import style1 from "./companyInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954b6a2",
  null
  
)

export default component.exports